import React from 'react'
import Header from '../components/probe-list/Header'
import StoryHeader from '../components/probe-list/StoriesHeader'
import Sections from '../components/probe-list/Sections'
// import list from '../testing/exercise/list'
import customRequest from '../helpers/customRequest'
import getURLParams from '../helpers/getURLParams'
import BeatLoader from 'react-spinners/BeatLoader'
import redirect from '../components/redirect/redirect'
import message from '../components/message/message'
import { Link } from 'react-router-dom'
import buildQuery from '../helpers/buildQuery'

class ProbesList extends React.Component
{
    state =
    {
        student: "",
        customer: null,
        studentCode: null,
        sections: [],
        suggestedStory: "high",
        suggestedProbe: {section: null, number: null},
        loading: true,
        selectedProbe: null
    }

    probeClick = (event, probeNumber) => {
        if (this.state.suggestedProbe.number != probeNumber) {
            event.preventDefault()
            window.$("#warning-modal").modal("show")
            this.setState({selectedProbe: probeNumber})
        }
    }

    updateList = () => {
        this.setState({loading: true})
        var params = getURLParams()
        customRequest.get('/api/probe-list', {
            params: {
                customerUsername: params.customer ?? null,
                studentName: params.student,
                type: this.props.type
            }
        })
        .then(({data}) =>
        {
            if (data.valid === false) {
                return redirect.send('/dashboard', () => {
                    message.error(data.message)
                })
            }
            
            this.setState({...data, student: params.student, customer: params.customer, loading: false})
        })
    }

    componentDidUpdate(prevProps)
    {
        if (prevProps.type != this.props.type)
        {
            this.updateList()
        }
    }

    componentDidMount()
    {
        window.$("#warning-modal").modal("hide")
        window.$("#warning-modal2").modal("hide")
        
        this.updateList()
    }

    render()
    {
        var {type, story} = this.props
        var {customer, student, studentCode, sections, suggestedProbe, suggestedStory, loading} = this.state

        let query = { student: student }
        if (customer) query['customer'] = customer
        const standardVariables = buildQuery(query)

        if (type === "high" || type === "middle" || type === "elementary")
        {
            type = "stories"
        }

        return (
            <React.Fragment>
                <Header student={student} studentCode={studentCode} customer={customer} active={type} story={story} suggestedStory={suggestedStory} loading={loading} />
                {type == "stories" ? <StoryHeader student={student} customer={customer} active={story} /> : ""}
                {
                    loading ?
                    <div style={{ margin: "0 auto", display: "table", height: "70vh"}}>
                        <div style={{ display: "table-cell", verticalAlign: "middle", textAlign: "center"}}>
                            <BeatLoader
                                size={15}
                                color={"#123abc"}
                                loading={true}
                                />
                        </div>
                    </div>
                    : <Sections student={student} customer={customer} sections={sections} suggested={suggestedProbe} suggestedStory={suggestedStory} url={this.props.type} probeClick={this.probeClick}/>
                }
            
            <div class = "modal fade" id = "warning-modal" role = "dialog">
                <div class = "modal-dialog modal-md">
                    <div class = "modal-content">
                        <div class = "modal-header">
                            <h4 class = "modal-title">STOP!</h4>
                            <button type = "button" class = "close" data-dismiss = "modal">&times;</button>
                        </div>
                        <div class = "modal-body row">
                        <p class = "offset-md-1 col-md-10">Please select the highlighted exercise to do with your student!</p>
                        </div>
                        <div class = "modal-footer">
                            <Link to = {`${this.props.type}/${suggestedProbe.number}?${standardVariables}${suggestedStory ? `&suggestedStory=${suggestedStory}` : ""}`}
                                onClick ={() => { window.$("#warning-modal").modal("hide") }}
                                class = "btn modal-btn btn-secondary button-inline suggested-link">Go to Suggested Exercise</Link>
                            <button type="button"
                                    class = "btn modal-btn btn-danger"
                                    data-dismiss = "modal"
                                    data-toggle="modal"
                                    data-target="#warning-modal2">Continue to Selected</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class = "modal fade" id = "warning-modal2" role = "dialog">
                <div class = "modal-dialog modal-md">
                    <div class = "modal-content">
                        <div class = "modal-header">
                            <h4 class = "modal-title">Are you sure you want to override the Great Leaps Digital Program?</h4>
                            <button type = "button" class = "close" data-dismiss = "modal">&times;</button>
                        </div>
                        <div class = "modal-body row">
                            <p class = "offset-md-1 col-md-10">Selecting this exercise is not following the Great Leaps Digital Program with fidelity and can adversely effect your student's growth.</p>
                        </div>
                        <div class = "modal-footer">
                            <Link to = {`${this.props.type}/${suggestedProbe.number}?${standardVariables}${suggestedStory ? `&suggestedStory=${suggestedStory}` : ""}`}
                                  onClick ={() => { window.$("#warning-modal2").modal("hide") }}
                                  class = "btn modal-btn btn-secondary button-inline suggested-link">Go to Suggested Exercise</Link>
                            <button type="button"
                                    data-dismiss = "modal"
                                    class = "btn modal-btn btn-danger"
                                    id = "override-link"
                                    onClick={() => {
                                        redirect.send(`${this.props.type}/${this.state.selectedProbe}?${standardVariables}${suggestedStory ? `&suggestedStory=${suggestedStory}` : ""}`)
                                    }}>Override program</button>
                        </div>
                    </div>
                </div>
            </div>
            </React.Fragment>
        )
    }
}

export default ProbesList
